export const AuthErrorTranslation = {
  fi: {
    AuthError: {
      backLink: 'Takaisin kirjautumissivulle',
      wentWrong: 'Jotain meni pieleen..',
    },
  },
};
